<div class="container-fluid container-background">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
            <div class="outer">
                <div class="middle">

                    <div class="login-form-container">
                        <div class="login-header-title">
                            <i class="zmdi zmdi-lock zdmi-fw"></i>
                            Set New Password:
                        </div>
                        <p class="login-header-para">
                            To complete your Sync account setup, you’ll need to set a new password:
                        </p>
                        <sync-error [errcode]="errcode"></sync-error>
                        <p *ngIf="spinner">
                            <i class="fa fa-spin fa-spinner"></i>
                            {{ isInviteChecked ? 'Resetting password...' : 'Verifying invite...'}}
                        </p>

                        <form *ngIf="isInviteChecked" (ngSubmit)="resetPasswordForm.valid && resetPasswordSubmit()"
                            [formGroup]="resetPasswordForm" ngNativeValidate>
                            <div>
                                <div class="form-group">
                                    <label>New Password:</label>
                                    <input type="password" placeholder="" value="" id="password"
                                        formControlName="password" required
                                        class="input-lg form-control login-form-control" name="password"
                                        syncShowHidePassword
                                        identity="resetpass" />
                                </div>
                                <sync-complex-password [password]="resetPasswordForm.controls.password.value"></sync-complex-password>
                                <div class="form-group">
                                    <label>Confirm Password:</label>
                                    <input required type="password" class="form-control login-form-control input-lg"
                                        id="confirmPassword" name="confirmPassword" formControlName="confirmPassword"
                                        placeholder=""
                                        syncShowHidePassword
                                        identity="resetpass" />
                                </div>
                            </div>
                            <button
                                [disabled]="!resetPasswordForm.touched || !resetPasswordForm.dirty || !resetPasswordForm.valid || spinner"
                                class="btn-block btn btn-primary btn-lg showhand">Set Password</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>